import ReduxAuthorizedComponent from './redux-authorized-component';

export default ReduxAuthorizedComponent;